(ns manatee.user.handlers
  (:require [ajax.core :refer [json-request-format json-response-format]]
            [kee-frame.core :as kf]
            [manatee.admin.rejection-option.handlers :as rejection-option-handler]
            [manatee.user.app-db :as user-db]
            [re-frame.core :as rf]
            [taoensso.timbre :as log]))

(defn user->api
  [{:keys [team] :as user}]
  (-> user
      (update-in [:is-active] #(if (nil? %)
                                 false
                                 %))
      (dissoc :team)
      (assoc :team-id (if (= :no-team team) nil (str team)))))

(defn user<-api
  [{:keys [team-id] :as user}]
  (-> user
      (dissoc :team-id)
      (assoc :team (or team-id :no-team))))

(defn teams<-api
  [teams]
  (cons {:id :no-team :name "<No team>"} teams))

(rf/reg-event-fx
 ::load-user-success
 (fn load-user-success
   [{:keys [db]} [_ user]]
   (cond-> {:db (-> db
                    (user-db/set-user user)
                    (user-db/set-status :success))}

           ;rejection-options must be loaded before user accesses Add Task. When Add Task is moved to admin/tasks (ELIT-3753) the loading of rejection-options here can be removed
     (= "admin" (:role user))
     (assoc :dispatch [::rejection-option-handler/load-rejection-options]))))

(rf/reg-event-fx
 ::load-user-failure
 (fn load-user-failure
   [{:keys [db]} [_ response]]
   (log/error "load-user-failure" (str response))
   {:db (user-db/set-status db :error)}))

(rf/reg-event-fx
 ::load-user
 (fn load-user
   [{:keys [db]} [_ auth-token]]
   {:db (user-db/set-status db :loading-user)
    :http-xhrio {:method :get
                 :uri (kf/path-for [:api/user])
                 :headers {:authorization (str "Token " auth-token)}
                 :format (json-request-format)
                 :response-format (json-response-format {:keywords? true})
                 :on-success [::load-user-success]
                 :on-failure [::load-user-failure]}}))

(rf/reg-event-fx
 ::reload-user
 [(rf/inject-cofx :cookie/get [:auth-token])]
 (fn reload-user
   [{{:keys [auth-token]} :cookie/get} _]
   {:dispatch [::load-user auth-token]}))
